import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'cbic-inner-component-image',
  templateUrl: './inner-component-image.component.html',
  styleUrls: ['./inner-component-image.component.scss']
})
export class InnerComponentImageComponent implements OnInit {
@Input() inputDataImage: any;
  

 
  constructor(
     private scrollHere:ElementRef,
     private changeDedectionRef: ChangeDetectorRef
  ) { 

    
  }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
 
  


}
